import { TransfoErrorCodes } from 'types/billShock.ts'

/** The amount of days it takes before the volumes of a day are available */
export const VOLUMES_DELAY_IN_DAYS = 3

export const HANDLED_CONSUMPTION_TRANSFO_ERRORS = [
  TransfoErrorCodes.E304_CONTRACT_TOO_YOUNG,
  TransfoErrorCodes.E444_MISSING_DECENTRALIZED_PRODUCTION,
  TransfoErrorCodes.E454_MISSING_SERVICE_DELIVERIES,
  TransfoErrorCodes.E456_DELIVERY_OUT_OF_SCOPE,
  TransfoErrorCodes.E547_DEFAULT_VALUES_IN_BILLSHOCK
] as const
